module.exports = __webpack_public_path__ + "img/register1.ca59704.png";